import { render, staticRenderFns } from "./BrainMulViz.vue?vue&type=template&id=3340d2e2&scoped=true"
import script from "./BrainMulViz.vue?vue&type=script&lang=js"
export * from "./BrainMulViz.vue?vue&type=script&lang=js"
import style0 from "./BrainMulViz.vue?vue&type=style&index=0&id=3340d2e2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3340d2e2",
  null
  
)

export default component.exports